import { CLEAR_NOTICE, SHOW_NOTICE } from './constants';

/** @param {{title: string, body: string, url: string, tag: string, badge: number}} notice the server's GameNotice */
export const showNotice = (notice) => ({ type: SHOW_NOTICE, payload: notice });
export const clearNotice = () => ({ type: CLEAR_NOTICE });
